
import Vue, { PropType } from 'vue';
import { AccessLevelOption } from '@/views/Runnits/RunnitManageAccessDialog/runnitOwnership';

/**
 * Who can access a board, as a row of cards to pick one from: each says what it
 * means, and the chosen one wears its colour. Real buttons, so each is reachable
 * by keyboard; `role="radio"` tells a screen reader which one is chosen.
 */
export default Vue.extend({
	name: 'RunnitAccessLevelOptions',
	props: {
		value: { type: String, default: null },
		options: { type: Array as PropType<AccessLevelOption[]>, required: true },
		disabled: { type: Boolean, default: false },
		label: { type: String, default: 'Who can access' },
	},
	methods: {
		onSelect (option: AccessLevelOption) {
			if (this.disabled || option.disabled || option.value === this.value) return;
			this.$emit('input', option.value);
		},
	},
});
